import React, {Fragment, useRef, useState,useEffect} from "react";
import {MobCard} from "../components/MobCard";
import {MobEditButton} from "../components/MobEditButton";
import {MobAddButton} from "../components/MobAddButton";
import {Trans} from "@lingui/react/macro";
import {DynamicIcon} from "lucide-react/dynamic";
import {Popover} from "antd-mobile";
import {contactCopie, ContactFormatFamilyLink} from "./functions";
import ModalAddField from "../../views/app-views/contact/ModalAddField";
import {useActionSheet} from "../providers/ActionSheetProvider";
import {t} from "@lingui/core/macro"
import {notification, Tag} from "antd";
import {MobEditButtonIcon} from "../components/MobEditButtonIcon";
import {checkForfait, checkPermissions} from "../../components/permissions/functions";
import IntlMessage from "../../components/util-components/IntlMessage";
import ApiService from "../../services/ApiService";
import ModalAddTag from "../../views/app-views/contact/ModalAddTag";
import {useNavigate} from "react-router-shim";
import {MOBCOLORS, MOBILE_PREFIX_PATH} from "../../configs/AppConfig";
import MobContactIcon from "../components/MobContactIcon";
import ModalEditEmails from "./ModalEditEmails";
import ModalAddChild from "../../views/app-views/contact/ModalAddChild";
import ModalAddFamilyLink from "../../views/app-views/contact/ModalAddFamilyLink";

export default function ContactTabRelations({selected}){

    return(
        <div style={{display:"flex",flexDirection:"column",gap:30,paddingTop:20}}>
            <CardEnfants selected={selected}/>
            <CardRelations selected={selected}/>
        </div>
    )
}

function CardEnfants({selected}) {
    const enfants=selected?.enfants || []

    const actionSheetManager = useActionSheet()
    const navigate=useNavigate();
    const modalAddChild=useRef(null);


    const onDeleteChild=async (id)=>{
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/child/unlink/" + selected.id + "/" + id)
        await selected.__refreshData()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    return(
        <>
        <div style={{display: "flex", flexDirection: "column", gap: 10}}>
            <div style={{display:"flex",alignSelf:"flex-end"}}>
                <MobAddButton text={(<Trans>Ajouter un bébé à ce contact</Trans>)} onClick={()=>modalAddChild.current.show(selected.id)}/>
            </div>

            {enfants.length>0 &&(
                <MobCard style={{boxShadow:"none",position:"relative"}}>
                    <div style={{display:"flex",flexDirection:"column",padding:"5px 10px"}}>

                        <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:"400"}}><Trans>Bébés</Trans></span>

                        {enfants.map((item,index)=>{
                            return(
                                <div key={item.id}>
                                    {index>0 &&(
                                        <Divider/>
                                    )}
                                    <div style={{display:"flex",flexDirection:"column",padding:"8px 0px"}}>

                                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>

                                            <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:5}}>
                                                <span style={{color:MOBCOLORS.blue.color,fontSize:18,textDecorationLine:"underline"}} onClick={()=>navigate(MOBILE_PREFIX_PATH+"/contacts/fiche/?id="+item.id)}><span style={{textTransform:"capitalize"}}>{item.prenom}</span> <span style={{textTransform:"uppercase",fontWeight:"bold"}}>{item.nom}</span></span>
                                                <MobContactIcon contact={item} reversed/>
                                            </div>

                                            <div style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                                gap: 10
                                            }}>
                                                <div style={{display: "flex", alignItems: "center"}}
                                                     onClick={() => {
                                                         actionSheetManager.confirm(t`Êtes-vous sûrs de vouloir retirer ce bébé : "${item.prenom} ${item.nom}" du contact ?`, () => {
                                                             onDeleteChild(item.id)
                                                         })
                                                     }}>
                                                    <DynamicIcon name={"trash-2"} color={MOBCOLORS.red.color} size={18}
                                                                 style={{
                                                                     display: "flex",
                                                                     justifyContent: "center",
                                                                     alignItems: "center"
                                                                 }}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )
                        })}
                    </div>
                </MobCard>
            )}
        </div>

            <ModalAddChild getRef={(ref) => modalAddChild.current = ref} onFinish={(id) => {
                navigate(MOBILE_PREFIX_PATH+"/contacts/fiche/?id="+id)
                selected.__refreshData()
            }}/>
        </>
    )
}

function CardRelations({selected}) {
    const modalAddFamilyLink = useRef(null)
    const actionSheetManager = useActionSheet()
    const navigate=useNavigate();

    const onDeleteFamilyLink=async (contact, type, notif = true)=>{
        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/familylink/delete/" + contact + "/" + type + "/" + selected.id)
        await selected.__refreshData()

        if (notif) {
            notification.success({
                message: <IntlMessage id="success.delete"/>
            })
        }
    }

    return(
        <>
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>

                <div style={{display:"flex",alignSelf:"flex-end"}}>
                    <MobAddButton text={(<Trans>Ajouter une relation à ce contact</Trans>)} onClick={()=>modalAddFamilyLink.current.show(selected.id,selected.nom+" "+selected.prenom)}/>
                </div>

                {selected.familyLinks?.length>0 &&(
                    <>
                        <MobCard style={{boxShadow: "none", position: "relative"}}>

                            <div style={{marginBottom:15,padding:"0 10px"}}>
                                <span style={{color:"#000",fontSize:18,fontWeight:"400"}}>{selected.nom} {selected.prenom} <Trans>est :</Trans></span>
                            </div>

                            {selected.familyLinks.map((item,index)=>{
                                var contact = selected.familyContacts.find(i => i.id === item.contact)
                                if (!contact) {
                                    //onDeleteFamilyLink(item.contact, item.type, false)
                                    contact = {
                                        nom: item.contact
                                    }
                                    return null
                                }

                                return(
                                    <div key={item.id}>
                                        {index>0 &&(
                                            <Divider/>
                                        )}
                                        <div style={{display:"flex",flexDirection:"column",padding:"8px 10px"}}>
                                            <span style={{color:"#000",fontSize:13,marginBottom:5,fontWeight:item.main?"bold":"400"}}>{item.key}</span>

                                            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>

                                                <div style={{display:"flex",alignItems:"center",gap:10}}>
                                                    <span>{ContactFormatFamilyLink(item.type,selected.homme)}</span>

                                                    <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:5}}>
                                                        <span style={{color:MOBCOLORS.blue.color,fontSize:18,textDecorationLine:"underline"}} onClick={()=>navigate(MOBILE_PREFIX_PATH+"/contacts/fiche/?id="+contact.id)}><span style={{textTransform:"capitalize"}}>{contact.prenom}</span> <span style={{textTransform:"uppercase",fontWeight:"bold"}}>{contact.nom}</span></span>
                                                        <MobContactIcon contact={contact} reversed/>
                                                    </div>
                                                </div>


                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                    gap: 10
                                                }}>
                                                    <div style={{display: "flex", alignItems: "center"}}
                                                         onClick={() => {
                                                             actionSheetManager.confirm(t`Êtes-vous sûrs de vouloir retirer la relation avec "${contact.prenom} ${contact.nom}" du contact ?`, () => {
                                                                 onDeleteFamilyLink(item.contact, item.type)
                                                             })
                                                         }}>
                                                        <DynamicIcon name={"trash-2"} color={MOBCOLORS.red.color} size={18}
                                                                     style={{
                                                                         display: "flex",
                                                                         justifyContent: "center",
                                                                         alignItems: "center"
                                                                     }}/>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                )
                            })}
                        </MobCard>
                    </>
                )}
            </div>

            <ModalAddFamilyLink getRef={(ref) => modalAddFamilyLink.current = ref} onFinish={() => selected.__refreshData()}/>
        </>
    )
}


function Divider() {
    return (
        <div style={{width: "100%", paddingLeft: "5%", opacity: 0.05}}>
            <div style={{width: "100%", borderTop: "1px solid #4A5568"}}/>
        </div>
    )
}
